import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { ReportAccessView } from '@webapp/platform/iam/feature-sets/ReportAccessView'
import messages from './messages'

export const ReportAccessPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.reportAccessTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.reportAccessTitle),
          escapeCaseFormatting: true,
        },
      ]}
    >
      <ReportAccessView />
    </Page>
  )
}
